module.exports = __webpack_public_path__ + "img/IMG_0907.b2282549.jpeg";